export default __webpack_public_path__ + "static/media/cancelled-event.63833dfe.svg";